import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/site";

export default function Refund() {
  return (
    <LegalLayout title="Refund & Cancellation Policy" updated="August 2026" testid="refund-page">
      <p>
        This policy explains how trials, cancellations and refunds work for {COMPANY.name}'s
        subscription software products (Kreta, Apoopika and Jigyasa). We keep it straightforward.
      </p>

      <LegalSection heading="1. Free trial">
        <p>
          Every product includes a 14-day free trial. No card or payment details are needed to
          start one, and nothing is charged during the trial. If you decide not to continue,
          simply stop using the product and you will not be billed.
        </p>
        <p>
          When a trial ends without payment, your account becomes read-only: you can view your
          data but not add or change it. Your data is preserved, and subscribing restores full
          access.
        </p>
      </LegalSection>

      <LegalSection heading="2. Subscriptions">
        <p>
          Subscriptions are billed monthly or yearly, at the prices published on each product's
          own website. Published prices are the total amount payable — Aumonline is not registered
          for GST, so no GST or other tax is added. You can cancel at any time; there is no
          lock-in and no cancellation fee.
        </p>
      </LegalSection>

      <LegalSection heading="3. Missed or failed renewals">
        <p>
          If a renewal payment does not go through, you keep full access for 7 days while we
          remind you of the overdue payment. After those 7 days the account becomes read-only.
          Your data stays intact, and paying the overdue amount restores full access.
        </p>
      </LegalSection>

      <LegalSection heading="4. Changing plans">
        <p>
          Upgrades apply immediately. Any unused paid days on your old plan are converted into
          free days on the new plan. Downgrades take effect from your next billing date.
        </p>
      </LegalSection>

      <LegalSection heading="5. What happens when you cancel">
        <p>
          When you cancel, your subscription stays active until the end of the period you have
          already paid for. You keep full access until that date and are not billed again. After
          that, your account becomes read-only and your data is retained, so you can return and
          reactivate whenever you wish.
        </p>
      </LegalSection>

      <LegalSection heading="6. No mid-period refunds">
        <p>
          Because access continues to the end of the paid period, we do not provide partial or
          pro-rated refunds for the current billing period.
        </p>
      </LegalSection>

      <LegalSection heading="7. Incorrect or duplicate charges">
        <p>
          If you are charged in error — for example a duplicate charge or a charge after a valid
          cancellation — contact us and we will verify and refund the incorrect amount to the
          original payment method.
        </p>
      </LegalSection>

      <LegalSection heading="8. How to cancel">
        <p>
          You can cancel from within your product account, or by emailing {COMPANY.email}. If you
          need help, call us at {COMPANY.phoneDisplay} and we will assist you.
        </p>
      </LegalSection>

      <LegalSection heading="9. Contact">
        <p>
          For any question about cancellations or refunds, email {COMPANY.email}. Our registered
          office is {COMPANY.addressLine1}, {COMPANY.addressLine2}.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
